import { cn } from '../../utils/cn'

// Negrito inline via **...**
function rich(text) {
  return text.split('**').map((part, index) =>
    index % 2 === 1 ? (
      <strong key={index} className="font-inter-bold">
        {part}
      </strong>
    ) : (
      part
    ),
  )
}

export default function MethodBlock({
  intro = 'Sobre o método',
  body = '',
  bulletsTitle = 'O que você passa a compreender',
  bullets = [],
  accentBorderClass = 'border-[#FF4D1C]',
}) {
  const half = Math.ceil(bullets.length / 2)
  const columns = [bullets.slice(0, half), bullets.slice(half)]

  return (
    <div className="w-full px-20">
      <div className="flex flex-col gap-6 pb-10">
        <h2 className="font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
          {intro}
        </h2>

        <div className={cn('border-l-4 pl-7', accentBorderClass)}>
          <p className="whitespace-pre-line font-inter-regular text-base leading-[1.08] tracking-[-0.02em] text-[#454545]">
            {rich(body)}
          </p>
        </div>
      </div>

      {bullets.length > 0 && (
        <div className="flex flex-col gap-6 pb-24">
          <h2 className="font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
            {bulletsTitle}
          </h2>

          <div className="flex flex-col gap-6 md:flex-row md:justify-between md:gap-[120px]">
            {columns.map((column, columnIndex) => (
              <ul
                key={columnIndex}
                className="flex flex-1 flex-col gap-6 ps-[27px]"
              >
                {column.map((bullet, index) => (
                  <li
                    key={index}
                    className="list-disc font-inter-regular text-lg leading-[1.08] tracking-[-0.02em] text-[#454545]"
                  >
                    {bullet}
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
